export const appBackBlueIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.1501 10.0833H7.36093L10.6426 6.7925L9.3501 5.5L3.8501 11L9.3501 16.5L10.6426 15.2075L7.36093 11.9167H18.1501V10.0833Z" fill="#8AABFF"/></svg>`,
    name: 'back-blue'
};